import { FieldMappingEditor } from '@/components/field-mapping-editor';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Info } from 'lucide-react';

export function FormProvidersPage() {
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Formulier Providers</h1>
        <p className="text-muted-foreground mt-2">Configureer veld mappings voor Jotform</p>
      </div>

      <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
        <div className="flex gap-2">
          <Info className="h-5 w-5 text-blue-600 shrink-0 mt-0.5" />
          <div className="text-sm text-blue-900">
            Er is momenteel enkel <strong>Jotform</strong> beschikbaar. Inkomende webhooks worden aan een groep
            gekoppeld, waarna deze mappings automatisch op die verwerking worden toegepast.
          </div>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Jotform Field Mappings</CardTitle>
          <CardDescription>
            Configureer hoe Jotform velden worden gemapt naar het interne schema. Deze mappings worden gebruikt bij
            verwerking van gekoppelde Jotform-webhooks.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <FieldMappingEditor provider="jotform" />
        </CardContent>
      </Card>
    </div>
  );
}
